import { SignupUser } from "@/src/types";
import api from "../api";

export async function signup(signupUser: SignupUser): Promise<any | null> {
    // force email to lowercase
    signupUser.email = signupUser.email.toLowerCase();

    const signupUserBody = {
        ...signupUser,
        establishment: {
            ...signupUser.establishment,
            establishmentType: Number(
                signupUser.establishment.establishmentType
            ),
            establishmentGroup: Number(
                signupUser.establishment.establishmentGroup
            ),
            region: signupUser.establishment.region != null ? Number(signupUser.establishment.region) : null,   
        },
    };

    return await api
        .post("auth/signup/", signupUserBody)
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response.data;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);
            if (error.response) {
                return error.response.data;
            }
            return error;
        });
}
